<template>
  <div id="app">
    <v-layout row wrap class="sticky">
      <v-flex xs12 md12>
        <div id="console" />
      </v-flex>
      <v-flex xs9>
        <video autoplay playsinline muted id="webcam" width="800" height="600" />
      </v-flex>

      <v-flex xs12>
        <v-btn small @click="instance.addExample(0)">Teach Set 1</v-btn>
        <v-btn small @click="instance.addExample(1)">Teach Set 2</v-btn>
        <v-btn small @click="instance.addExample(2)">Teach Set 3</v-btn>
        <v-btn small @click="instance.addExample(3)">Teach Set 4</v-btn>

        <v-btn small color="red" dark @click="instance.destroy()">Terminate</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Teach from "../lib/Teach";
export default {
  data: () => ({
    instance: null,
    scrollSpeed: 15
  }),
  mounted() {
    // Create Instance
    this.instance = new Teach("webcam", this.fnGoUp, this.fnGoDown);
    this.instance.init();

    //this.instance.destroy()
  },
  methods: {
    fnGoUp() {
      window.scrollBy(0, -this.scrollSpeed);
    },
    fnGoDown() {
      window.scrollBy(0, this.scrollSpeed);
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#console {
  font-size: 15px;
  line-height: 90%;
  padding-left: 10px;
}
</style>